import angular from 'angular'

import { ROUTES } from '../../../lib/routes'
import { $q, $window } from '../ng-compat/imports'

/**
 * Intercepts $http response errors and redirects to the signin page if the error was a 401 unauthorized.
 *
 * @module webregister.http.RedirectSigninOn401
 */
function redirectSigninOn401() {
  let _hasEncountered401 = false

  return {
    hasEncountered401() {
      return _hasEncountered401
    },

    responseError(response: Response) {
      if (response.status === 401) {
        _hasEncountered401 = true
        const { href } = $window.location

        const returnUrl = href.includes(ROUTES.ERROR_OFFLINE)
          ? ROUTES.WEB_REGISTER
          : href

        $window.location.href = `/signin?return=${encodeURI(returnUrl)}`
      }

      return $q.reject(response)
    },
  }
}

export type RedirectSigninOn401 = ReturnType<typeof redirectSigninOn401>

angular
  .module('webregister.http')
  .factory('redirectSigninOn401', redirectSigninOn401)
